import React, { useState } from 'react'
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { PiWarningCircleBold } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import { deleteLead } from '../../../redux/actions/Files.action';

const DeleteModal = ({ deleteModal, deleteToggle, setChecked, leadId, limits, setLeadId, setMainPage, searchDefault1 }) => {
    const dispatch = useDispatch()
    const [loader, setLoader] = useState(false);

    const handleDelete = () => {
        setLoader(true);
        const payload = {
            patientIds: leadId
        }
        dispatch(deleteLead(payload, limits, searchDefault1.status)).then(() => {
            setLoader(false);
            deleteToggle(false);
            setLeadId([])
            setMainPage(1)
            setChecked(false)
        })
    }

    return (
        <>
            {loader && (
                <div className="loaderAdd">
                    <div className="loader_line"><img src={localStorage.getItem('logo')} className="w-[130px]" /></div>
                </div>
            )}
            <Modal show={deleteModal} onHide={deleteToggle} >
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer className=''>
                    <Button variant="secondary" onClick={deleteToggle} className='px-4 bg-transparent border-[1px] text-black border-green-color'>
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
};

export default DeleteModal;
